import { TCredit } from '@/shared/types/Billing';

export const getPricePerMin = (product?: TCredit) => {
  if (!product) {
    return 0;
  }

  return (product.prices?.[0]?.unit_amount ?? 0) / 100;
};
